import {Chip, Stack, ToggleButton} from '@mui/material';
import {Chat} from '@services/Chat/types';
import {useChatContext} from '../context';
import {ContactOptionItem} from './ContactOptionItem';

type Props = {
    chat: Chat;
};

export default function ChatListItem({chat}: Props) {
    const {selectedChat, handleSelectChat} = useChatContext();

    return (
        <ToggleButton
            value={chat.id}
            onClick={() => {
                handleSelectChat(chat);
            }}
            selected={selectedChat?.id === chat.id}
            size='small'
            sx={{
                my: 0.5,
                height: '32px',
                textTransform: 'none',
                justifyContent: 'flex-start',
                width: '100%',
                borderRadius: '0px',
                '&.MuiToggleButton-root': {
                    border: 'none',
                },
                '&.Mui-selected': {
                    borderRadius: '8px',
                },
                '&.MuiToggleButton-root:hover': {
                    borderRadius: '8px',
                },
            }}
        >
            <Stack
                direction='row'
                gap={2}
                alignItems='center'
                justifyContent='space-between'
                width='100%'
            >
                <Stack
                    direction='row'
                    gap={1}
                    alignItems='center'
                    sx={{minWidth: 0}}
                >
                    <ContactOptionItem
                        option={chat}
                        size={24}
                    />
                </Stack>
                {chat.unreadMessages! > 0 && (
                    <Chip
                        label={chat.unreadMessages}
                        size='small'
                        sx={{
                            maxWidth: '50px',
                            borderRadius: '100px',
                            color: 'black',
                        }}
                        color='primary'
                    />
                )}
            </Stack>
        </ToggleButton>
    );
}
